module.exports = __webpack_public_path__ + "static/media/D1_C3_001.c10c214c.png";